import { createAction, createSlice } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';

import type { SelfVehiclePlanVehicle } from '../lib/types';

export const SET_SELF_VEHICLE_PLAN = 'vehiclePlan/self/set';
export const SET_PLANNED_VEHICLE_PLAN = 'vehiclePlan/planned/set';

export const DEL_SELF_VEHICLE_PLAN = 'vehiclePlan/self/delete';
export const DEL_PLANNED_VEHICLE_PLAN = 'vehiclePlan/planned/delete';

export type VehiclePlanState = {
  selfVehicles: Map<number, SelfVehiclePlanVehicle> | null;
  plannedVehicles: Map<number, SelfVehiclePlanVehicle> | null;
};

const initialState: VehiclePlanState = {
  selfVehicles: new Map(),
  plannedVehicles: new Map()
};

const setSelfVehiclePlan = createAction<Map<number, SelfVehiclePlanVehicle>>(
  SET_SELF_VEHICLE_PLAN
);
const setPlannedVehiclePlan = createAction<Map<number, SelfVehiclePlanVehicle>>(
  SET_PLANNED_VEHICLE_PLAN
);
const deleteSelfVehiclePlan = createAction<Map<number, SelfVehiclePlanVehicle>>(
  DEL_SELF_VEHICLE_PLAN
);
const deletePlannedVehiclePlan = createAction<Map<number, SelfVehiclePlanVehicle>>(
  DEL_PLANNED_VEHICLE_PLAN
);

const vehiclePlanSlice = createSlice({
  name: 'vehiclePlan',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(setSelfVehiclePlan, (state, { payload }) => {
        state.selfVehicles = new Map(payload);
      })
      .addCase(setPlannedVehiclePlan, (state, { payload }) => {
        state.plannedVehicles = new Map(payload);
      })
      .addCase(deleteSelfVehiclePlan, (state, { payload }) => {
        state.selfVehicles = new Map(payload);
      })
      .addCase(deletePlannedVehiclePlan, (state, { payload }) => {
        state.plannedVehicles = new Map(payload);
      });
  }
});

export const vehiclePlanActions = {
  setSelf: setSelfVehiclePlan,
  setPlanned: setPlannedVehiclePlan,
  deleteSelf: deleteSelfVehiclePlan,
  deletePlanned: deletePlannedVehiclePlan
};

export const addVehiclePlanVehicle = (
  selfVehiclePlanVehicle: Map<number, SelfVehiclePlanVehicle>,
  self: boolean = true
) => async (dispatch: Dispatch) => {
  dispatch(
    self
      ? vehiclePlanActions.setSelf(selfVehiclePlanVehicle)
      : vehiclePlanActions.setPlanned(selfVehiclePlanVehicle)
  );
};

export const setVehiclePlanVehicle = (
  selfVehiclePlanVehicle: Map<number, SelfVehiclePlanVehicle>,
  self: boolean = true
) => async (dispatch: Dispatch) => {
  dispatch(
    self
      ? vehiclePlanActions.setSelf(selfVehiclePlanVehicle)
      : vehiclePlanActions.setPlanned(selfVehiclePlanVehicle)
  );
};

export const deleteVehiclePlanVehicle = (
  selfVehiclePlanVehicle: Map<number, SelfVehiclePlanVehicle>,
  self: boolean = true
) => async (dispatch: Dispatch) => {
  dispatch(
    self
      ? vehiclePlanActions.deleteSelf(selfVehiclePlanVehicle)
      : vehiclePlanActions.deletePlanned(selfVehiclePlanVehicle)
  );
};

export default vehiclePlanSlice.reducer;
